export default function postData(url, token, data = {}) {
    const controller = new AbortController();
    const signal = controller.signal;
    return [fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token.token}`
        },
        redirect: 'follow',
        referrer: 'no-referrer',
        body: JSON.stringify({...data}),
        signal
    }).then((response) => response.json()), controller.abort.bind(controller)]
}

export function getData(url, token=null) {
    const controller = new AbortController();
    const signal = controller.signal;
    let headers = {
        'Content-Type': 'application/json'
    }
    if(token !== null) headers = {...headers, 'Authorization': `Bearer ${token.token.toString()}`}
    return [fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: headers,
        redirect: 'follow',
        referrer: 'no-referrer',
        signal
    }).then((response) => response.json()), controller.abort.bind(controller)]
}

export function postFormData(url, data, token) {
    const controller = new AbortController();
    const signal = controller.signal;
    return [fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrer: 'no-referrer',
        headers: {
            'Authorization': `Bearer ${token.token}`
        },
        body: data,
        signal
    }).then((response) => response.json()), controller.abort.bind(controller)]
}
